var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundFooter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1500,
    height: 195,
    viewBox: "0 0 1500 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 36.2584V183H1501V12.4016C1501 12.4016 1032.5 60.3405 857.194 55.6139C640.163 49.7622 493.103 -6.8914 265.433 0.698303C80.3113 6.86961 0 36.2584 0 36.2584Z",
    fill: "#1FB1E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 48.2584V195H1500V24.4016C1500 24.4016 1031.81 72.3405 856.623 67.6139C639.736 61.7622 492.774 5.10861 265.257 12.6983C80.2578 18.8696 0 48.2584 0 48.2584Z",
    fill: "#4BC1E7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundFooter);
export default __webpack_public_path__ + "static/media/backgroundFooter.1422afc686a53193ac1fca9c87ab929e.svg";
export { ForwardRef as ReactComponent };